var _defs, _g;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgFeedback(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: "32px",
    height: "32px",
    viewBox: "0 0 32 32",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title === undefined ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, "1F5686AA-654A-42AD-B71C-5597ACAFAF19") : title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("rect", {
    id: "path-1",
    x: 0,
    y: 0,
    width: 32,
    height: 32
  }))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Web-app",
    stroke: "none",
    strokeWidth: 1,
    fill: "none",
    fillRule: "evenodd"
  }, /*#__PURE__*/React.createElement("g", {
    id: "web-home",
    transform: "translate(-863, -602)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group-2-Copy",
    transform: "translate(845, 602)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "feedback",
    transform: "translate(18, 0)"
  }, /*#__PURE__*/React.createElement("mask", {
    id: "mask-2",
    fill: "white"
  }, /*#__PURE__*/React.createElement("use", {
    xlinkHref: "#path-1"
  })), /*#__PURE__*/React.createElement("g", {
    id: "Rectangle"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M25.3333333,4 C27.5424723,4 29.3333333,5.790861 29.3333333,8 L29.3333333,20 C29.3333333,22.209139 27.5424723,24 25.3333333,24 L16.5679422,24 L9.21827982,29.4363893 L9.21827982,24 L6.66666667,24 C4.45752767,24 2.66666667,22.209139 2.66666667,20 L2.66666667,8 C2.66666667,5.790861 4.45752767,4 6.66666667,4 L25.3333333,4 Z M25.3333333,6.66666667 L6.66666667,6.66666667 C5.930287,6.66666667 5.33333333,7.26362033 5.33333333,8 L5.33333333,20 C5.33333333,20.7363797 5.930287,21.3333333 6.66666667,21.3333333 L11.8849465,21.3333333 L11.884,24.1466667 L14.9821392,21.8560924 L15.6888771,21.3333333 L25.3333333,21.3333333 C26.069713,21.3333333 26.6666667,20.7363797 26.6666667,20 L26.6666667,8 C26.6666667,7.26362033 26.069713,6.66666667 25.3333333,6.66666667 Z",
    id: "Rectangle",
    fill: "#FFFFFF",
    fillRule: "nonzero",
    mask: "url(#mask-2)"
  })))))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgFeedback);
export default __webpack_public_path__ + "static/media/feedback.8d870ab1c69381ae7f1d818a71f59384.svg";
export { ForwardRef as ReactComponent };